import { env } from 'libs/constants/env';

class RecaptchaProvider {
  private static instance: RecaptchaProvider;
  static _subscriptionKey = env.SUBSCRIPTION_KEY;
  private _keyCaptcha = '';
  private _loadKeyCaptcha: any = null;

  private constructor() {}

  public static getInstance(): RecaptchaProvider {
    if (!RecaptchaProvider.instance) {
      RecaptchaProvider.instance = new RecaptchaProvider();
    }

    return RecaptchaProvider.instance;
  }

  public saveCaptcha = (keyCaptcha: string) => {
    this._keyCaptcha = keyCaptcha;
  };

  public getCaptcha = () => {
    return this._keyCaptcha;
  };

  public saveLoadKeyCaptcha = (loadKeyCaptcha: any) => {
    this._loadKeyCaptcha = loadKeyCaptcha;
  };

  public getLoadKeyCaptcha = () => {
    return this._loadKeyCaptcha;
  };
}

export default RecaptchaProvider;
